module.exports = __webpack_public_path__ + "static/media/oh_pack1_sample005_0005.8df50bba.png";